export default {
    home: {
      title: '首页'
    },
    members: {
      title: '团队'
    },
    publications: {
      title: '成果'
    },
    teaching: {
      title: '教学'
    },
    opening: {
      title: '开放信息'
    },
    notFound: {
      title: '页面未找到'
    },
  };
